import { Industry } from 'src/app/Models/Industry';
import { TreeNode } from 'primeng/api';
import { environment } from 'src/environments/environment';


export function ReformatIndustry(industry: Industry, lang: string, expanded: boolean = false): TreeNode {
    return {
        label:  (lang == 'ru')
            ? industry.Name
            : (lang == 'kk')
                ? industry.NameKz
                : industry.NameEn,
        data: industry.Id,
        icon: (industry.Activity != null)
            ? (industry.Activity.Id == environment.handbooksStaticFIelds.AnalyticalActivityTypeId)
                ? 'fas fa-chart-pie'
                : (industry.Activity.Id == environment.handbooksStaticFIelds.OperationalActivityTypeId)
                    ? 'fas fa-heartbeat'
                    : ''
            : '',
        expanded,
        children: industry.Children.length > 0 ? industry.Children.map(x => ReformatIndustry(x, lang)) : []
    }
}